var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":_vm.register}},[_c('div',{staticClass:"register"},[_c('h2',{staticClass:"register-header"},[_vm._v("Registration")]),_vm._v(" "),_c('TextField',{attrs:{"placeholder":"your@email.com","fullWidth":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}},[_c('template',{slot:"label"},[_vm._v(" Email ")])],2),_vm._v(" "),_c('TextField',{attrs:{"placeholder":"John Snow","fullWidth":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}},[_c('template',{slot:"label"},[_vm._v(" User Name ")])],2),_vm._v(" "),_c('SelectBox',{attrs:{"selected":_vm.lang,"onSelect":_vm.onLanguageChange,"options":[
        'en',
        'ru',
        'aa',
        'bg',
        'de',
        'es',
        'fi',
        'it',
        'ja',
        'mr',
        'no',
        'pl',
        'ro',
        'se',
        'tr',
        'zh',
        'he',
        'hi',
        'hy'
      ]}},[_c('template',{slot:"label"},[_vm._v(" Language ")])],2),_vm._v(" "),_c('TextField',{attrs:{"placeholder":"• • • • • • • • •","type":"password","fullWidth":""},model:{value:(_vm.pass),callback:function ($$v) {_vm.pass=$$v},expression:"pass"}},[_c('template',{slot:"label"},[_vm._v(" Password ")])],2),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"error"},[_vm._v("Some fields are incorrect")]):_vm._e(),_vm._v(" "),_c('Btn',{staticClass:"register-button",attrs:{"onClick":_vm.register,"variant":"contained","color":"primary","size":"lg"}},[_vm._v("\n      REGISTER\n    ")]),_vm._v(" "),_c('div',[_vm._v("\n      Already have an account?\n      "),_c('router-link',{staticClass:"link login-link",attrs:{"to":"/login"}},[_vm._v(" Login ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }